// extracted by mini-css-extract-plugin
export default {"common_header_info":"HeaderInfo_common_header_info__2Yf2H","content":"HeaderInfo_content__uP2ma","icon":"HeaderInfo_icon__BdcGq"};